import type { CoordItem } from "../../types";

export function coordinateOwnershipStats(items: CoordItem[]) {
  const known = items.some((item) => item.owned !== undefined);
  const owned = items.filter((item) => item.owned === true).length;
  return {
    known,
    owned,
    total: items.length,
    complete: known && items.length > 0 && items.every((item) => item.owned === true),
  };
}
